import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { COLOR_PALETTE } from 'constants/ui';

import { BadgeColorVariant, BadgeType } from './BadgeCDS.constants';
import { getDotStyles, getSidebarStyles } from './BadgeCDS.styles';

const BadgeCDS = ({
  type = BadgeType.SIDEBAR,
  colorVariant = BadgeColorVariant.BRAND,
  value = '',
}) => {
  if (type === BadgeType.DOT) {
    return <Box sx={getDotStyles(colorVariant)} />;
  }

  return (
    <Box sx={getSidebarStyles(colorVariant)}>
      <Typography color={COLOR_PALETTE.GRAY[1]} variant="medium12">
        {value}
      </Typography>
    </Box>
  );
};

BadgeCDS.propTypes = {
  type: PropTypes.oneOf(Object.values(BadgeType)),
  colorVariant: PropTypes.oneOf(Object.keys(BadgeColorVariant)),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BadgeCDS;
